import type { dataSafety as dataSafetyEn } from '../en/dataSafety';

export const dataSafety: typeof dataSafetyEn = {
  title: 'Proteger su registro',
  intro:
    'Todo lo que registra se guarda en este teléfono. Dos cosas lo mantienen seguro: permitir que el navegador lo proteja y guardar un archivo de respaldo que usted conserve.',

  protectedOn: 'El almacenamiento protegido está activado',
  protectedOnBody:
    'Le pedimos a su navegador que no borre esta aplicación para liberar espacio.',
  protectedOff: 'El almacenamiento protegido está desactivado',
  protectedOffBody:
    'Su navegador podría borrar esta aplicación si el teléfono se queda sin espacio. Activarlo hace que eso sea mucho menos probable.',
  protectButton: 'Activar almacenamiento protegido',
  protectDeclined:
    'Su navegador aún no lo permitió. Agregar la aplicación a la pantalla de inicio y usarla unos días suele ser suficiente.',

  exportButton: 'Guardar un archivo de respaldo',
  exporting: 'Preparando…',
  exportHint:
    'Un solo archivo con cada toma, pañal y peso. Guárdelo en Archivos, iCloud o Google Drive.',
  exportShared: (n: number) => `Respaldo listo con ${n} ${n === 1 ? 'registro' : 'registros'}.`,
  exportDownloaded: (n: number) =>
    `Respaldo guardado con ${n} ${n === 1 ? 'registro' : 'registros'}. Revise sus descargas.`,
  exportFailed: 'No se pudo crear el archivo de respaldo. Inténtelo de nuevo.',

  importButton: 'Restaurar desde un respaldo',
  importing: 'Restaurando…',
  importHint:
    'Traiga un respaldo a este teléfono. No se pierde nada de lo que ya tiene: siempre gana lo más reciente.',
  importDone: (added: number, updated: number) =>
    updated > 0
      ? `Se restauraron ${added} ${added === 1 ? 'registro nuevo' : 'registros nuevos'} y se actualizaron ${updated}.`
      : `Se ${added === 1 ? 'restauró' : 'restauraron'} ${added} ${added === 1 ? 'registro' : 'registros'}.`,
  importNothingNew: 'Ese respaldo ya estaba al día. No cambió nada.',
  importBadFile: 'Ese archivo no parece ser un respaldo de First Weeks.',
  importFailed: 'No se pudo leer ese archivo. Inténtelo de nuevo.',

  clearWarning:
    'Algo importante: si borra los datos de su navegador o elimina la aplicación, este registro se pierde con ellos. Un archivo de respaldo es la única forma de recuperarlo.',
  usage: (size: string, date: string) => `Usando ${size} al ${date}.`,
};
